import api from "./api";

// export const login = (data) => {
//   return api('get', `/saml/pre-login`, data)
// }
export const validation = data => {
  return api("get", `/v1/management/login/validation`, data);
};
export const getUserInfo = data => {
  return api("get", `/bo/user/info/`, data);
};
export const logout = data => {
  return api("post", `/v1/sso/admin/logout`, data);
};
export const getAuthor = params => {
  return api("get", `/v1/management/member/author`, params);
};
